import { Component } from '@angular/core';

@Component({
  selector: 'app-email-sp',
  imports: [],
  templateUrl: './email-sp.html',
  styleUrl: './email-sp.css',

})
export class Spanish {}
